/* GET ADGROUP NOTES*/
export const GET_ADGROUP_NOTES = "GET_ADGROUP_NOTES"
export const GET_ADGROUP_NOTES_SUCCESS = "GET_ADGROUP_NOTES_SUCCESS"
export const GET_ADGROUP_NOTES_ERROR = "GET_ADGROUP_NOTES_ERROR"

/*CREATE ADGROUP NOTES*/
export const CREATE_ADGROUP_NOTES = "CREATE_ADGROUP_NOTES"
export const CREATE_ADGROUP_NOTES_SUCCESS = "CREATE_ADGROUP_NOTES_SUCCESS"
export const CREATE_ADGROUP_NOTES_ERROR = "CREATE_ADGROUP_NOTES_ERROR"

/*UPDATE ADGROUP NOTES*/
export const UPDATE_ADGROUP_NOTES = "UPDATE_ADGROUP_NOTES"
export const UPDATE_ADGROUP_NOTES_SUCCESS = "UPDATE_ADGROUP_NOTES_SUCCESS"
export const UPDATE_ADGROUP_NOTES_ERROR = "UPDATE_ADGROUP_NOTES_ERROR"

/*DELETE ADGROUP */
export const DELETE_ADGROUP_NOTES = "DELETE_ADGROUP_NOTES"
export const DELETE_ADGROUP_NOTES_SUCCESS = "DELETE_ADGROUP_NOTES_SUCCESS"
export const DELETE_ADGROUP_NOTES_ERROR = "DELETE_ADGROUP_NOTES_ERROR"